import { EmeraldError } from 'src/common/api/emerald-error';
import { AbortedError, ProhibitActionError } from 'src/common/api/extended-emerald-error';
import { restorePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { store } from 'src/common/redux/configure-store';
import { ActivityType } from 'src/operation-notify/enum/activities.enum';
import { operationNotify } from 'src/operation-notify/operation-notify';
import { EntryMethod } from '../../common/enumerations/entry-method';
import { IItemInputData } from '../../common/interfaces/IItemInputData';
import { popupMessage } from '../../messages/business-logic/popup-message';
import {
  getSalesKeypadState,
  resetSalesKeypadState,
} from '../../sales-keypad/business-logic/sales-keypad-operations';
import { showDepartmentSalePage } from '../components/department-sale';
import { sellDepartmentItem } from './sell-department-item';
import { getDepartments } from './service/get-departments';

export const handleDepartmentSale = async (inputData: IItemInputData): Promise<void> => {
  const activityType = store.getState().posMode.returnMode.returnType
    ? ActivityType.DepartmentReturn
    : ActivityType.DepartmentSale;
  await operationNotify(activityType);

  const departments = await getDepartments();
  if (departments?.length) {
    return new Promise<void>((resolve, reject) => {
      const onAccept = (departmentSaleInputData: IItemInputData, newPrice: number): void => {
        sellDepartmentItem(departmentSaleInputData, newPrice)
          .then(() => {
            resetSalesKeypadState();
            resolve();
          })
          .catch(err => {
            if (err instanceof AbortedError || err instanceof ProhibitActionError) {
              reject(err);
            } else {
              popupMessage(err);
            }
          });
      };
      const onCancel = (): void => {
        reject(new AbortedError());
      };

      showDepartmentSalePage({
        inputData,
        departments,
        onAccept,
        onCancel,
      });
    }).finally(() => restorePage());
  } else {
    throw new EmeraldError('No_Department_Found');
  }
};

export const initiateDepartmentSale = async (): Promise<void> => {
  const { itemCode, metricValue, isManualWeight, quantityEntered } = getSalesKeypadState();
  const itemInputData: IItemInputData = {
    itemId: itemCode,
    entryMethod: EntryMethod.Keyed,
    quantity: metricValue || 1,
    quantityEntryMethod: quantityEntered ? EntryMethod.Keyed : EntryMethod.Automatic,
    isManualWeight: isManualWeight,
  };

  return handleDepartmentSale(itemInputData).catch(popupMessage);
};
